import { StepBadge } from "./StepBadge"

interface SectionHeaderProps {
  step: number
  title: string
  subtitle?: string
}

export function SectionHeader({ step, title, subtitle }: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <StepBadge step={step} />
        <h2 className="text-2xl font-semibold tracking-tight text-foreground">
          {title}
        </h2>
      </div>
      {subtitle && (
        <p className="ml-10 text-sm text-muted-foreground">{subtitle}</p>
      )}
    </div>
  )
}
